
const HALF_WIDTH_MODAL = 165;

export default {
    name: 'ShareSocialNetwork',
    props: {
        networks: {
            type: Array,
            default: () => ['vk', 'telegram']
        },
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        copyLink: {
            type: Boolean,
            default: true
        },
        header: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            show: false,
            position: 'default'
        }
    },
    computed: {
        url() {
            return `https://cofi.ru${this.$route.fullPath}`;
        }
    },
    methods: {
        hide() {
            this.show = false;
        },
        handleCopy() {
            window.navigator.clipboard.writeText(this.url);
            this.hide();
        },
        handleShow() {
            if (!this.show) {
                const nuxtWidth = document.querySelector('#__nuxt').offsetWidth;
                const buttonRect = this.$refs.button.getBoundingClientRect();

                if (nuxtWidth - buttonRect.right - HALF_WIDTH_MODAL < 0) {
                    this.position = 'right';
                } else if (buttonRect.left < HALF_WIDTH_MODAL) {
                    this.position = 'left';
                } else {
                    this.position = 'default';
                }
            }

            this.show = !this.show;
        }
    }
}
